<template>
  <div
    data-test="bulk-action-bar"
    class="flex flex-wrap items-center gap-2 rounded-md border border-primary bg-primary-50 px-3 py-1.5 text-sm dark:bg-slate-700"
  >
    <span class="font-semibold">
      {{ $t('global.tasks_selected_count', { count }) }}
    </span>
    <button
      type="button"
      data-test="bulk-delete"
      data-faro-user-action-name="task.bulk_delete"
      class="flex items-center gap-1.5 rounded-md bg-red-600 px-2 py-1 text-xs font-medium text-white enabled:hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
      :disabled="isOverLimit || busy"
      @click="$emit('delete')"
    >
      <FontAwesomeIcon :icon="['fal', 'trash']" />
      <span class="capitalize-first">{{ $t('button.delete') }}</span>
    </button>
    <button
      type="button"
      data-test="bulk-clear"
      class="rounded-md px-2 py-1 text-xs hover:bg-gray-200 dark:hover:bg-slate-600"
      @click="$emit('clear')"
    >
      <span class="capitalize-first">{{ $t('button.unselect_all') }}</span>
    </button>
    <span
      v-if="isOverLimit"
      data-test="bulk-limit"
      class="text-xs text-red-700 dark:text-red-400"
    >
      {{ $t('global.tasks_bulk_delete_limit', { max }) }}
    </span>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/** Bulk actions of the task dashboard selection: delete it, or clear it. */
export default {
  name: 'TaskBulkActionBar',
  components: { FontAwesomeIcon },
  props: {
    count: { type: Number, required: true },
    max: { type: Number, required: true },
    /** A deletion is running: no second one until it ends. */
    busy: { type: Boolean, required: false, default: false }
  },
  emits: ['delete', 'clear'],
  computed: {
    isOverLimit() {
      return this.count > this.max
    }
  }
}
</script>
